const marketInitialState = {
  cars: [],
  loading: false,
}

export default marketInitialState;
